// First, let's split the providers into separate files
import { BaseProviders } from './provider-groups/base-providers';
// Split routes into logical groups
import { newAppRoutes } from './route-groups/new-app-routes';
import { createRoutesFromElements, Route, Outlet, Navigate } from 'react-router-dom';
import { paths } from './paths';
import RequireAuth from './require-auth';
import { OfflinePage } from '../new/pages/offline-page';
import { newAuthRoutes } from './route-groups/new-auth-routes';
import { ReactRouterErrorBoundary } from './react-router-error-boundary';
import { newPublicRoutes } from './route-groups/new-public-routes';
import { RootLayout } from '../new/layouts/root-layout';
import { BillingProvider } from '../new/hooks/use-billing-listener';
import { onboardingRoutes } from './route-groups/onboarding-routes';
import { LinkedinProvider } from '../new/hooks/use-linkedin';
import { HAS_VISITED_AGENT_PAGE_KEY } from '../new/pages/home/agent-page';

// Create a component for the home redirect that checks localStorage
const HomeRedirect = () => {
    const hasVisitedAgentPage = localStorage.getItem(HAS_VISITED_AGENT_PAGE_KEY) === 'true';
    return <Navigate to={hasVisitedAgentPage ? paths.NEW.HOME : paths.NEW.ACTIONS} replace />;
};

export const routes = createRoutesFromElements(
    <Route
        element={
            <BaseProviders>
                <RootLayout />
            </BaseProviders>
        }
        ErrorBoundary={ReactRouterErrorBoundary}
    >
        {/* Public Routes */}
        {newPublicRoutes}

        {/* Auth Routes */}
        {newAuthRoutes}

        {/* App Routes */}
        <Route element={<RequireAuth requiredUserState={'loggedin_user_selected'} />}>
            <Route
                element={
                    <BillingProvider>
                        <LinkedinProvider>
                            <Outlet />
                        </LinkedinProvider>
                    </BillingProvider>
                }
            >
                {onboardingRoutes}
                {newAppRoutes}
            </Route>
        </Route>

        {/* Fallbacks and other Routes */}
        <Route
            // errorElement={<ErrorPage />}
            element={<RequireAuth requiredUserState={'offline'} />}
        >
            <Route path={paths.SERVER_OFFLINE} element={<OfflinePage />} />
        </Route>
        {/* Redirect Routes */}
        <Route path={paths.HOME} element={<HomeRedirect />} />
        <Route path="*" element={<Navigate to={paths.HOME} replace />} />
    </Route>
);
